export default __webpack_public_path__ + "static/media/up_arrow.9f2990ac.svg";